import singleRouterList from '@/router/singleRouterList';
import store from "@/store";

export default [
  {
    path: '/',
    name: 'index',
    redirect: '/index',
    component: () => import('@/components/layout/index.vue'),
    children: [
      {
        path: '/index',
        name: 'landing',
        component: () => import('@/views/static/landing.vue'),
        meta: {
          title: '首页',
          type: 'static',
          footer: true,
          icon: 'iconhome-24px',
          menu: true,
        }
      },
      {
        path: '/app-detail/:app?',
        name: 'appDetail',
        defaultPath: '/app-detail',
        component: () => import('@/views/static/appDetail.vue'),
        props: true,
        meta: {
          title: '产品详情',
          type: 'static',
          icon: 'icondevices-24px',
          menu: true,
        }
      },
      {
        path: '/guide',
        name: 'guide',
        component: () => import('@/views/static/guide.vue'),
        meta: {
          title: '接入指南',
          type: 'static',
          icon: 'iconfact_check-24px',
          menu: true,
          footer: true,
        }
      },
      {
        path: '/document/:doc?',
        name: 'apiDocument',
        defaultPath: '/document',
        props: true,
        meta: {
          type: 'static',
          title: 'API文档',
          icon: 'iconinsert_drive_file-24px',
          menu: true,
        },
        component: () => import('@/views/static/docs.vue'),
      },
      {
        path: '/faq',
        name: 'faq',
        component: () => import('@/views/static/faq.vue'),
        meta: {
          title: '联系我们与常见问题',
          type: 'static',
          icon: 'iconlocal_phone-24px',
          menu: true,
          footer: true,
        },
      },
      {
        path: '/faq/inquiry',
        name: 'inquiry',
        component: () => import('@/views/static/inquiry.vue'),
        meta: {
          title: '购买咨询',
          type: 'static',
          icon: 'iconhome-24px',
          footer: true,
        }
      },
      {
        path: '/faq/techsupport',
        name: 'techSupport',
        component: () => import('@/views/static/techSupport.vue'),
        meta: {
          title: '技术支持',
          type: 'static',
          icon: 'iconhome-24px',
          footer: true,
        }
      },
      {
        path: '/terms',
        name: 'terms',
        component: () => import('@/views/static/terms.vue'),
        meta: {
          type: 'static',
        }
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        redirect: '/dashboard/account-view',
        component: () => import('@/components/layout/dashboard.vue'),
        meta: {
          title: '控制面板',
          icon: 'iconapps-24px',
          loginRequired: true,
        },
        children: [
          {
            path: '/dashboard/notifmgmt',
            name: 'dashboard-notifmgmt',
            meta: {
              title: '消息管理',
              permission: 'notification',
              loginRequired: true,
            },
            component: () => import('@/views/notifMgmt/index.vue')
          },
          {
            path: '/dashboard/account-view',
            name: 'dashboard-accountView',
            meta: {
              title: '账户概览',
              permission: 'account',
              loginRequired: true,
            },
            component: () => import('@/views/dashboard/accountView/accountView.vue'),
          }, {
            path: '/dashboard/monitor',
            name: 'dashboard-monitor',
            meta: {
              title: '数据监控',
              keepAlive: true,
              permission: 'monitor',
              loginRequired: true,
            },
            component: () => import('@/views/dataMonitor/dataMonitor.vue'),
          }, {
            path: '/dashboard/application',
            name: 'dashboard-application',
            meta: {
              title: '应用管理',
              permission: 'service',
              loginRequired: true,
            },
            component: () => import('@/components/layout/layoutViewer.vue'),
            redirect: '/dashboard/application/my-service',
            children: [
              {
                path: '/dashboard/application/my-service',
                name: 'dashboard-application-myService',
                meta: {
                  title: '我的服务',
                  permission: 'service_my',
                  loginRequired: true,
                },
                component: () => import('@/views/application/myService/myService.vue'),
              }, {
                path: '/dashboard/application/key',
                name: 'dashboard-application-key',
                meta: {
                  title: '密钥管理',
                  permission: 'service_aksk',
                  loginRequired: true,
                },
                component: () => import('@/views/application/accessKey/accessKey.vue'),
              },
            ],
          }, {
            path: '/dashboard/settlement',
            name: 'dashboard-settlement',
            meta: {
              title: '结算中心',
              permission: 'settlement',
              loginRequired: true,
            },
            component: () => import('@/components/layout/layoutViewer.vue'),
            redirect: to => {
              const roles = store.state.user.role_list.map(r => r.role_name);
              if (roles.includes("financial"))
                return '/dashboard/settlement/payment';
              return '/dashboard/settlement/contract';
            },
            children: [
              {
                path: '/dashboard/settlement/balance',
                name: 'dashboard-settlement-balance',
                meta: {
                  title: '账户余额',
                  permission: 'settlement_balance',
                  loginRequired: true,
                },
                component: () => import('@/views/settlement/balance/balance.vue'),
              }, {
                path: '/dashboard/settlement/bill',
                name: 'dashboard-settlement-bill',
                meta: {
                  title: '我的账单',
                  permission: 'settlement_bill',
                  loginRequired: true,
                },
                component: () => import('@/views/settlement/bill/bill.vue'),
              }, {
                path: '/dashboard/settlement/contract',
                name: 'dashboard-settlement-contract',
                meta: {
                  title: '合同管理',
                  permission: 'settlement_contract',
                  loginRequired: true,
                },
                component: () => import('@/views/settlement/contract/contract.vue'),
              }, {
                path: '/dashboard/settlement/payment',
                name: 'dashboard-settlement-payment',
                meta: {
                  title: '支付管理',
                  permission: 'payment',
                  loginRequired: true,
                },
                component: () => import('@/views/settlement/payment/payment.vue'),
              },
            ],
          },
          {
            path: '/dashboard/usermgmt',
            name: 'dashboard-usermgmt',
            meta: {
              title: '客户管理',
              permission: 'usermgmt',
              loginRequired: true,
            },
            component: () => import('@/components/layout/layoutViewer.vue'),
            redirect: '/dashboard/usermgmt/monitor',
            children: [
              {
                path: '/dashboard/usermgmt/monitor',
                name: 'dashboard-usermgmt-monitor',
                meta: {
                  title: '使用监控',
                  permission: 'usermgmt_monitor',
                  loginRequired: true,
                },
                component: () => import('@/views/usermgmt/monitor.vue'),
              }, {
                path: '/dashboard/usermgmt/service',
                name: 'dashboard-usermgmt-service',
                meta: {
                  title: '服务管理',
                  permission: 'usermgmt_service',
                  loginRequired: true,
                },
                component: () => import('@/views/usermgmt/service.vue'),
              }, {
                path: '/dashboard/usermgmt/payment',
                name: 'dashboard-usermgmt-payment',
                meta: {
                  title: '支付管理',
                  permission: 'usermgmt_payment',
                  loginRequired: true,
                },
                component: () => import('@/views/usermgmt/payment/payment.vue'),
              },
            ],
          },
        ],
      },
      {
        path: '/user',
        name: 'dashboard-user',
        meta: {
          title: '我的账户',
          type: 'hidden',
          loginRequired: true,
        },
        component: () => import('@/views/userInfo/userInfo.vue'),
      },
      ...singleRouterList,
    ],
  },
];
